import { FaBookOpen } from 'react-icons/fa';
import { BlogViewMain } from '../Components/BlogViewMain';

export const BlogModule = () => [{
    views: 'PRIVATE', path: '/dashboard/blog', component: <BlogViewMain />,
    roles: null, permissions: null, label: 'Blog', icon: <FaBookOpen />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
